export const avatarRoute = '/avatar';
export const apiPrefix = '/api';
export const avatarRouteCreate = avatarRoute + '/' + 'create';
export const avatarRouteUpdate = avatarRoute + '/' + 'update';
export const avatarRouteDelete = avatarRoute + '/' + 'delete';
export const avatarRouteList = avatarRoute + '/' + 'list';
export const platformAvatarsList = avatarRoute + '/' + 'platform-avatars';
export const platformScenesList = avatarRoute + '/' + 'platform-scenes';
export const voicesList = avatarRoute + '/voices';
export const loginRoute = avatarRoute + '/login';
export const staticRoute = apiPrefix + '/static';
export const platformStaticRoute = apiPrefix + '/platform_static';
export const addPictureRoute = '/add_picture';
export const avatarBrainService = avatarRoute + '/brain';
export const avatarTrialEmailRoute = apiPrefix + "/avatar_trial_email/";
